import React, { useState, useEffect, useCallback, memo } from "react";
import PropTypes from "prop-types";

function VideoPreviewItem({ file, index, onRemove }) {
  const [objectUrl] = useState(() =>
    file && file instanceof File ? URL.createObjectURL(file) : ""
  );
  useEffect(() => {
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);
  const handleRemove = useCallback(
    (e) => {
      e.stopPropagation();
      onRemove(index);
    },
    [index, onRemove]
  );
  if (!objectUrl) return null;
  return (
    <div className="relative flex-shrink-0 rounded-lg overflow-hidden bg-black border border-white/20 shadow-md">
      <video
        src={objectUrl}
        controls
        playsInline
        className="w-24 h-24 object-cover"
        aria-label={`Recorded video ${index + 1}`}
      />
      <button
        type="button"
        className="absolute top-0 right-0 w-6 h-6 rounded-full bg-black/60 text-white flex items-center justify-center text-sm hover:bg-black/80"
        onClick={handleRemove}
        aria-label={`Remove video ${index + 1}`}
      >
        ×
      </button>
    </div>
  );
}

VideoPreviewItem.propTypes = {
  file: PropTypes.instanceOf(File).isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default memo(VideoPreviewItem);
